import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import { useAuthDispatch, useAuthState } from "../../context/AuthContext";
import {
  Container,
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Avatar,
  Checkbox,
  FormControlLabel,
  Link,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const Login = () => {
  const { isAuthenticated } = useAuthState();
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: "", password: "" });
  const [rememberMe, setRememberMe] = useState(
    localStorage.getItem("rememberMe") === "true"
  );
  const [error, setError] = useState("");

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await axios.post("/api/v1/auth/login", form);
      const { access_token, token_type, user } = response.data;

      localStorage.setItem("token", access_token);
      localStorage.setItem("token_type", token_type);
      localStorage.setItem("userRole", user.role);

      if (rememberMe) {
        localStorage.setItem("rememberMe", "true");
      } else {
        localStorage.removeItem("rememberMe");
      }

      dispatch({
        type: "LOGIN",
        payload: {
          access_token,
          token_type,
          role: user.role,
        },
      });

      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    }
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Paper
        elevation={2}
        sx={{
          padding: 3,
          mt: 10,
          borderRadius: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography
            variant="h5"
            component="h1"
            fontWeight="bold"
            color="#fff"
          >
            Sign In
          </Typography>

          {error && (
            <Typography color="error" align="center" mb={2}>
              {error}
            </Typography>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              size="small"
              margin="dense"
              required
              autoFocus
              sx={{ input: { color: "#fff" }, label: { color: "#fff" } }}
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              size="small"
              margin="dense"
              required
              sx={{ input: { color: "#fff" }, label: { color: "#fff" } }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={handleRememberMeChange}
                  name="rememberMe"
                  size="small"
                  color="primary"
                />
              }
              label="Remember Me"
              sx={{ color: "#fff", mt: 1 }}
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              size="small"
              color="primary"
              sx={{ mt: 2 }}
            >
              Login
            </Button>

            <Box mt={2} display="flex" justifyContent="space-between">
              <Link
                href="/forgot-password"
                variant="body2"
                sx={{ color: "#fff", textDecoration: "none" }}
              >
                Forgot Password?
              </Link>
              <Link
                href="/sign-up"
                variant="body2"
                sx={{ color: "#fff", textDecoration: "none" }}
              >
                Don't have an account? Sign Up
              </Link>
            </Box>
          </form>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login;
